



















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
// types
import { News, NewsDto, LanguageEnum } from "@/services/news/types";
// service methods
import {
    createNews,
    getNewsById,
    updateNews
} from "@/services/news/newsService";
// components
import NewsInstanceGroups from "@/components/news/NewsInstanceGroups.vue";
import HeaderActionButtons from "@/components/layouts/HeaderActionButtons.vue";
import NewsSchedule from "@/components/news/NewsSchedule.vue";
import TextForm from "@/components/news/textAndImage/TextForm.vue";
import ImageForm from "@/components/news/image/ImageForm.vue";
import VideoForm from "@/components/news/video/VideoForm.vue";

@Component({
    components: {
        NewsInstanceGroups,
        HeaderActionButtons,
        NewsSchedule,
        TextForm,
        ImageForm,
        VideoForm
    },
    filters: {
        form(value: string) {
            if (!value || value === "") return "";
            return value.concat("Form");
        }
    }
})
export default class NewsForm extends Vue {
    @Prop() private id!: string;
    @Prop() newsType!: string;

    // local state
    news = { id: "", name: "", content: [], fromDate: "", toDate: "", type: this.newsType, instanceGroupIds: [] } as NewsDto;

    formState = false;
    changeItemName = false;
    itemScheduled = false;
    fileContent = [] as Array<any>;
    localCollapseState = true;
    languages = Object.keys(LanguageEnum).map((key: any) => LanguageEnum[key]).filter(value => typeof value === "string") as string[];
    saveClicked = false;

    // lifecycle hooks
    public created() {
        this.fetchData();
    }

    // Watcher
    firstTime = true as boolean;
    @Watch("$route", { immediate: true, deep: true })
    onUrlChange(newVal: any) {
        if (this.firstTime) {
            this.firstTime = false;
        } else {
            this.fetchData();
        }
    }

    // Computed
    get newsDetails(): any {
        return {
            name: this.news.name,
            type: this.news.type,
            fromDate: this.news.fromDate,
            toDate: this.news.toDate
        } as News;
    }

    get editMode() {
        return !!this.id;
    }

    get showNameInput() : boolean {
        return this.changeItemName;
    }

    get newsTypeKey(): string {
        if (this.newsType) { return this.newsType; }
        if (this.news && this.news.type) { return this.news.type; }
        return "";
    }

    get newsTypeFormatted() {
        return this.toCamelCase(this.newsTypeKey);
    }

    imgSrc(lang: string) {
        return require("@/components/news/flags/flag_" + lang + ".png");
    }

    onNewsInstanceGroupsUpdated(instanceGroups: string[]) {
        if (!this.news.instanceGroupIds) {
            this.news.instanceGroupIds = [] as string[];
        }

        this.news.instanceGroupIds = this.news
            .instanceGroupIds
            .concat(instanceGroups.filter(u => !this.news.instanceGroupIds.includes(u)));
    }

    save() {
        if (this.saveClicked) return;
        this.saveClicked = true;

        this.childComponentsHandler();
        const formData = new FormData();
        (this.fileContent as any).forEach((x: any) => {
            if (!x.file.type) return;
            formData.append(`${x.language}`, x.file, x.file.name);
        });
        formData.append("model", JSON.stringify(this.news));
        if (!this.editMode) {
            createNews(formData).then(() => {
                this.saveClicked = false;
                this.$router.push("/news");
            });
        } else {
            updateNews(formData).then(() => {
                this.saveClicked = false;
                this.$router.push("/news");
            });
        }
    }

    fetchData() {
        if (this.editMode) {
            getNewsById(this.id).then(response => {
                this.news = response;
            });
        }
    }

    childComponentsHandler() {
        const components = this.$refs.childComponents as any[];
        this.news.content = [];
        this.fileContent = [];
        (this.$refs.instanceGroupsComponent as any).emitData();
        components.forEach(component => {
            component.emitData();
        });
    }

    toggleName(event: any) {
        this.changeItemName = false;
    }

    onScheduleUpdated(isValid: boolean) {
        this.itemScheduled = isValid;
    }

    onContentUpdated(newsContent: any, file: File) {
        this.news.content.push(newsContent);
        const fileLanguage = { file: file, language: newsContent.language as string } as any;
        this.fileContent.push(fileLanguage);
    }

    setState(state:boolean) {
        if (this.localCollapseState === state) return;

        this.localCollapseState = state;
    }

    toCamelCase(value: string) {
        return value.length > 5 ? value.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, "") : value.toLowerCase();
    }

    back() {
        this.$router.push("/news");
    }
}
